// const reserveFields = ['user', 'users', 'console', 'title', 'user_id', 'model_id', 'slug', 'title', 'description', 'body', 'created_at', 'updated_at']

let validate = {
  phone (value) {
    if (value.length === 11 && /^((13|14|15|17|18|16|19)[0-9]{1}\d{8})$/.test(value)) {
      return true
    } else {
      return '请输入11位手机号码'
    }
  }
}

export default validate
